<template>
  <div>
    <div class="header" style="background:#000">
      <div class="container clearfix">
        <el-row class="PC">
          <el-col :span="3">
            <div class="index-logo">
              <router-link to="/">
                <img src="/static/images/u-logo.png" style="height:60px"/>
              </router-link>
            </div>
          </el-col>
          <el-col :span="21" class="f-view-r-c-e">
            <el-menu
              :default-active="activeIndex"
              :active-text-color="activeColor"
              :router="true"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/">热播广播剧</el-menu-item>
              <el-menu-item index="/">优秀广播剧</el-menu-item>
              <el-menu-item index="/">下载APP</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg Mobile" justify="space-between">
          <el-col :span="8" class="m-box">
            <div class="menu-btn" @click="mobileNav">
              <span></span><span></span><span></span>
            </div>
          </el-col>
          <el-col :span="8" class="m-box m-index-logo" style="padding: 0">
            <router-link to="/">
              <img src="/static/images/u-logo.png" style="height:50px;margin-top:15px;"/>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
    <div :class="['mobile-nav', [mobile_nav ? 'm-nav-show' : 'm-nav-hide']]">
      <el-row>
        <el-col :span="12" style="padding-left: 20px">
          <img src="/static/images/u-logo.png" />
        </el-col>
        <el-col :span="12" class="text-right" style="padding-right: 20px">
          <i
            class="el-icon-close"
            @click="mobileNav"
            style="color: #ffffff; font-size: 30px"
          ></i>
        </el-col>
      </el-row>
      <el-menu
        :default-active="activeIndex"
        :active-text-color="activeColor"
        :router="true"
        class="el-menu-vertical-demo"
        background-color="transparent"
        text-color="#fff"
        style="margin: 20px 0"
      >
        <el-menu-item index="/" class="m-menu-icon icon1" @click="mobileNav">
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item
          index="/"
          class="m-menu-icon icon2"
          @click="mobileNav"
        >
          <span slot="title">热播广播剧</span>
        </el-menu-item>
        <el-menu-item
          index="/"
          class="m-menu-icon icon3"
          @click="mobileNav"
        >
          <span slot="title">优秀广播剧</span>
        </el-menu-item>
        <el-menu-item
          index="/"
          class="m-menu-icon icon4"
          @click="mobileNav"
        >
          <span slot="title">下载APP</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-content">
      <div class="index-con">
        <div class="banner hidden-sm-and-down">
          <div class="swiper-container gallery-top">
            <div class="swiper-wrapper" style="height: 700px">
              <div
                v-for="(item, index) in banner"
                :key="index"
                class="swiper-slide"
              >
                <img class="img" :src="item.thumbUrl"  style="width:100%"/>
              </div>
            </div>
          </div>
        </div>
        <div class="m-banner hidden-md-and-up" style="margin-top:80px;">
          <div class="swiper-container gallery-top-banner">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in banner"
                :key="index"
                class="swiper-slide"
              >
                <img
                  class="img"
                  :src="item.thumbUrl"
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="container-hot hidden-sm-and-down">
          <Sm-Hot key="hot"/>
        </div>
        <div class="container-hot hidden-md-and-up">
          <Md-Hot/>
        </div>

        <div class="container-good hidden-sm-and-down">
          <Sm-Good/>
        </div>
        <div class="container-good hidden-md-and-up">
          <Md-Good/>
        </div>

        <div
          class="w100 hidden-sm-and-down"
          style="background: #000"
        >
          <Sm-Download/>
        </div>
        <div
          class="w100 clearfix pos-rel hidden-md-and-up"
          style="background: #000"
        >
          <Md-Download/>
        </div>

        <div class="w100 clearfix hidden-sm-and-down" style="background: #000">
          <Sm-Cooperation/>
        </div>
        
        <div class="w100 clearfix hidden-md-and-up" style="background: #000">
          <Md-Cooperation/>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import SmHot from "@/page/homepage/components/sm/hot";
import SmGood from "@/page/homepage/components/sm/good";
import SmDownload from "@/page/homepage/components/sm/download";
import SmCooperation from "@/page/homepage/components/sm/cooperation";

import MdHot from "@/page/homepage/components/md/hot";
import MdGood from "@/page/homepage/components/md/good";
import MdDownload from "@/page/homepage/components/md/download";
import MdCooperation from "@/page/homepage/components/md/cooperation";

import Footer from "@/components/footer/Footer";

// more module style...

export default {
  name: "homepage",
  components: {
    Footer,
    SmHot,
    SmGood,
    SmDownload,
    SmCooperation,
    MdHot,
    MdGood,
    MdDownload,
    MdCooperation
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 10, //大轮播图间距
        navigation: {
          //大轮播图的切图按钮，如果想放在轮播图中可以看swiper官方文档
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: {
            el: ".gallery-thumbs",
            slidesPerView: 6, //缩略图显示张数
            slidesPerGroup: 6, //缩略图每组切图张数
            spaceBetween: 10, //缩略图间距
            slideToClickedSlide: true,
            navigation: {
              //缩略图的切图按钮，如果想放在轮播图中可以看swiper官方文档
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          },
          autoScrollOffset: true,
        },
      },
      activeIndex: 0,
      activeColor: "",
      mobile_nav: false,
      value2: 0,
      banner: [
        {
          web: "CMBI",
          imgUrl: "/static/images/album/slide03.png",
          thumbUrl: "/static/images/album/slide03.png",
        },
      ]
    };
  },
  methods: {
    handleSelect(val) {},
    mobileNav() {
      this.mobile_nav = !this.mobile_nav;
    }
  },
  created() {
    
  },
  mounted() {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.el-menu {background:transparent}
</style>



// WEBPACK FOOTER //
// src/page/homepage/index.vue